import React, { useState, useEffect } from "react";
import { Input, FormGroup, Label, Button, Table, Spinner } from "reactstrap";
import { useNavigate, useParams } from "react-router-dom";
import axios from "axios";
import { AiOutlineDelete } from "react-icons/ai";
import { useSelector } from "react-redux";
import { toast } from "react-toastify";

const AddGallery = () => {
    const [imageFiles, setImageFiles] = useState([]);
    const [videoFile, setVideoFile] = useState(null);
    const [imgs, setimg] = useState([]);
    const { id } = useParams();
    const [formData, setFormData] = useState({
        place_id: id,
        caption: "",
        type: "",
        video_url: "",
        status: 1,
        images: "",
    });
    const [errors, setErrors] = useState({});
    const [message, setMessage] = useState("");

    const {
        AuthReducer: { auth },
        indexReducer: { places, loading }
    } = useSelector((state) => state);

    const navigate = useNavigate();

    const inputHandler = (e) => {
        const { name, value, type, files, checked } = e.target;
        if (name === "images" && files) {
            setFormData({ ...formData, [name]: files });
        } else if (type === "checkbox" && name === "status") {
            setFormData({ ...formData, [name]: checked ? 1 : 0 });
        } else {
            setFormData({ ...formData, [name]: value });
        }
    };

    const handleImageChange = (event) => {
        const files = Array.from(event.target.files);
        setImageFiles(files);
    };

    const handleSubmit = async () => {
        const form = new FormData();

        imageFiles.forEach((file) => {
            form.append('images', file);
        });

        Object.entries(formData).forEach(([key, value]) => {
            if (key !== 'images') form.append(key, value);
        });

        if (videoFile) form.append("video", videoFile);
        if (formData.video_url) form.append("video_url", formData.video_url);

        try {
            const res = await axios.post(`/api/admin/v1/add-town-gallery`, form, {
                headers: {
                    Authorization: `Bearer ${auth?.token}`,
                },
            });
            toast.success(res.data?.message);
            navigate(-1);
        } catch (err) {
            toast.error(err.response?.data);
            setErrors(err.response?.data?.errors || {});
            setMessage(err.response?.data?.message || "Something went wrong");
        }
    };
    useEffect(() => {
        axios(`/api/admin/v1/edit-gallery-town/${id}`, {
            headers: {
                Authorization: `Bearer ${auth?.token}`,
            },
        }).then((res) => {
            setimg(res.data?.data?.town_gallery_images);
        }).catch((err) => console.log(err));
    }, [auth]);

    const handleDelimageImage = (id) => {
        if (window.confirm("Are You Sure You Want To Delete This Gallery image.")) {
            axios.delete(`/api/admin/v1/town-gallery-image-delete/${id}`, {
                headers: {
                    Authorization: `Bearer ${auth?.token}`,
                },
            }).then((res) => {
                toast.success(res.data.message);
                window.location.reload();
            }).catch((err) => toast.error("Somthing Went Wrong"));
        }
    };


    return (
        <div>
            <div className="row my-3">
                <div className="col-md-12">
                    <h4 className="text-white">Add Town Gallery</h4>
                </div>
            </div>

            <div className="bg-white px-3 py-4 rounded-2 my-4">
                <div className="row">
                    {message && <h3 className="d-block text-danger text-center">{message}</h3>}
                    <div className="col-md-4 offset-md-1">
                        <FormGroup>
                            <Label>Caption <span className="text-danger fs-4">*</span></Label>
                            <Input
                                invalid={Boolean(errors?.caption)}
                                value={formData.caption}
                                name="caption"
                                onChange={inputHandler}
                            />
                            <span className="d-block text-danger">{errors?.caption}</span>
                        </FormGroup>
                    </div>
                    <div className="col-md-4 offset-md-1">
                        <FormGroup>
                            <Label className="text-black">Type</Label>
                            <Input
                                value={formData.type}
                                type="select"
                                name="type"
                                onChange={inputHandler}
                            >
                                <option value="">Select Type</option>
                                <option value="1">Image</option>
                                <option value="2">Video</option>
                            </Input>
                            <span className="d-block text-danger">{errors?.type}</span>
                        </FormGroup>
                    </div>
                    {formData.type === "2" && (
                        <>
                            <div className="col-md-4 offset-md-1">
                                <FormGroup>
                                    <Label className="text-black">Upload Video</Label>
                                    <Input
                                        type="file"
                                        accept="video/*"
                                        onChange={(e) => setVideoFile(e.target.files[0])}
                                    />
                                </FormGroup>
                            </div>
                            <div className="col-md-4 offset-md-1">
                                <FormGroup>
                                    <Label className="text-black">Video URL</Label>
                                    <Input
                                        value={formData.video_url}
                                        invalid={Boolean(errors?.video_url)}
                                        name="video_url"
                                        onChange={inputHandler}
                                    />
                                    <span className="d-block text-danger">{errors?.video_url}</span>
                                </FormGroup>
                            </div>
                        </>
                    )}

                    {formData.type === "1" && (
                        <div className="col-md-4 offset-md-1">
                            <FormGroup>
                                <Label>Upload Thumbnail</Label>
                                <Input
                                    type="file"
                                    name="images"
                                    invalid={Boolean(errors?.images)}
                                    multiple
                                    onChange={handleImageChange}
                                />
                                <span className="d-block text-danger">{errors?.images}</span>
                            </FormGroup>
                        </div>
                    )}

                    <div className="col-md-4 offset-md-1">
                        <FormGroup switch>
                            <Input
                                type="switch"
                                checked={formData.status === 1}
                                onChange={inputHandler}
                                name="status"
                            />
                            <Label check>Status</Label>
                        </FormGroup>
                    </div>

                    <div className="col-md-4 offset-md-4">
                        <Button color="primary" onClick={handleSubmit}>Submit</Button>
                        <Button className="ms-3" onClick={() => navigate(-1)}>Cancel</Button>
                    </div>
                </div>
            </div>
            <Table hover responsive className="mt-2">
                <thead>
                    <tr>
                        <th>SL. No.</th>
                        <th>Image</th>
                        <th>Action</th>
                    </tr>
                </thead>
                {loading ? (
                    <Spinner />
                ) : (
                    <tbody>
                        {imgs?.map?.((items, index) => {
                            return (
                                <tr>
                                    <th scope="row">{index + 1}</th>
                                    <td>
                                        <img
                                            src={`https://india-tourism.s3.ap-south-1.amazonaws.com/${items?.gallery_image}`}
                                            height={45}
                                            width={45}
                                        />
                                    </td>

                                    <td>
                                        <AiOutlineDelete
                                            size={22}
                                            onClick={() => handleDelimageImage(items.id)}
                                            className="text-danger"
                                        />
                                    </td>
                                    <td></td>
                                </tr>
                            );
                        })}
                    </tbody>
                )}
            </Table>
        </div>
    );
};

export default AddGallery;